function toFiniteAmount(value, fallback = 0) {
  const amount = Number(value);

  return Number.isFinite(amount)
    ? amount
    : fallback;
}

export function getPublicWebsiteSlotAmount(
  slot,
  fallback = 0,
) {
  return toFiniteAmount(
    slot?.price ??
      slot?.amount ??
      slot?.totalAmount,
    fallback,
  );
}

export function getPublicBookingSlotPriceLabel(
  slot,
  {
    fallbackCurrency = "INR",
    fallback = "Price on request",
  } = {},
) {
  const amount = getPublicWebsiteSlotAmount(
    slot,
    null,
  );

  if (
    amount === null ||
    amount === undefined ||
    amount === ""
  ) {
    return fallback;
  }

  const currency =
    String(
      slot?.currency ||
        fallbackCurrency ||
        "INR",
    )
      .trim()
      .toUpperCase() ||
    "INR";

  return `${currency} ${amount}`;
}

export function getPublicBookingSummary({
  selectedItemsTotal,
  reservation,
}) {
  const clientTotal = toFiniteAmount(
    selectedItemsTotal,
    0,
  );

  if (!reservation) {
    return {
      subtotal: clientTotal,
      discountAmount: 0,
      finalAmount: clientTotal,
      amountDue: clientTotal,
      promoCode: "",
    };
  }

  const subtotal = toFiniteAmount(
    reservation?.slot_price ??
      reservation?.originalTotalAmount ??
      reservation?.totalAmount,
    clientTotal,
  );

  const discountAmount = Math.max(
    0,
    toFiniteAmount(
      reservation?.discount_amount ??
        reservation?.promoDiscountAmount,
      0,
    ),
  );

  const finalAmount = Math.max(
    0,
    toFiniteAmount(
      reservation?.final_amount ??
        reservation?.totalAmount,
      Math.max(0, subtotal - discountAmount),
    ),
  );

  const amountDue = Math.max(
    0,
    toFiniteAmount(
      reservation?.dueAmount,
      finalAmount,
    ),
  );

  return {
    subtotal,
    discountAmount,
    finalAmount,
    amountDue,
    promoCode: String(
      reservation?.promo_code ??
        reservation?.promoCode ??
        "",
    )
      .trim()
      .toUpperCase(),
  };
}
